import { isPrerenderOld } from '@df/core/service/client';
import { gtmAwait } from '@df/module-gtm/integration/gtm-inclusion';

let initPromise: Promise<void> | undefined;

const config = typeof window !== 'undefined' ? window.dfConfig.oneTrust : undefined;

export function onetrustLoad(): Promise<void> {
    if (!initPromise) {
        initPromise = load();
        gtmAwait(done => initPromise!.finally(done));
    }

    return initPromise;
}

async function load() {
    if (!config || !config.id || !config.enabled || typeof document === 'undefined' || isPrerenderOld) {
        return;
    }

    if (config.autoBlock && config.autoBlockEnabled) {
        await loadScript(config.autoBlock.replace('{{ID}}', config.id));
    }

    const textScript = await loadScript();
    textScript.text = 'function OptanonWrapper() { }';

    await loadScript(config.sdk, textScript, { dataset: { documentLanguage: true, domainScript: config.id } });
}

function loadScript(url?: string, afterElement?: HTMLScriptElement, options?: { dataset?: any }): Promise<HTMLScriptElement> {
    return new Promise<HTMLScriptElement>((resolve, reject) => {
        if (typeof document === 'undefined') {
            return reject('Not a browser env');
        }
        const script = document.createElement('script');
        if (url) {
            if (options?.dataset) {
                for (const key in options.dataset) {
                    script.dataset[key] = options.dataset[key];
                }
            }
            script.async = true;
            script.src = url;
            script.type = 'text/javascript';
            script.onload = () => resolve(script);
            script.onerror = reject;
        }
        if (afterElement) {
            afterElement.parentNode!.insertBefore(script, afterElement.nextSibling);
        } else {
            document.head.prepend(script, document.getElementsByTagName('script')[0]);
        }
        if (!url) {
            resolve(script);
        }
    });
}
